import react, {useState} from 'react';
import AppBar from '@mui/material/AppBar';
import CssBaseline from '@mui/material/CssBaseline';
import Toolbar from '@mui/material/Toolbar';
import GlobalStyles from '@mui/material/GlobalStyles';
import logo from './eternadna-logo.png'
import Switch from '@mui/material/Switch';
import FormControlLabel from '@mui/material/FormControlLabel';


function NavigationBar({handleLanguage}) {

  return (
    <div>
      <GlobalStyles styles={{ ul: { margin: 0, padding: 0, listStyle: 'none' } }} />
      <CssBaseline />
      <AppBar
        position="static"
        elevation={0}
        style={{ background: '#fff', padding: '16px' }}
      >
        <Toolbar sx={{ display:'flex', justifyContent: 'space-between', flexWrap: 'wrap', margin: '12px 0px', ['@media (max-width:400px)']: {justifyContent: 'center', flexDirection: 'column', gap: '24px'} }}>
          <img src={logo} height="40"/>
          <nav>
          <FormControlLabel
          value="questions_chi"
          onChange={handleLanguage}
          control={<Switch color="primary" />}
          label="中文 "
          labelPlacement="end"
          sx={{fontWeight:"bold"}}
        />
          </nav>
        </Toolbar>
      </AppBar>
    </div>
  )
}

export default NavigationBar